module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "acknowledgment"
    }
  }, [_c('h1', [_vm._v("Acknowledgement")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("This book is blessed with a wealth of inputs and insights from other people, from whose great expertise and authority I have borrowed. Oliver Burkeman’s regular column in "), _c('em', [_vm._v("The Guardian")]), _vm._v("—‘This column will change your life’—was a huge source of inspiration, as was his book "), _c('em', [_vm._v("The Antidote: Happiness for people who can’t stand positive thinking")]), _vm._v(".")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("The influencing academic sources are obvious—Richard Dawkins’ "), _c('em', [_vm._v("The Selfish Gene")]), _vm._v(" and Susan Blackmore’s "), _c('em', [_vm._v("The Meme Machine")]), _vm._v(" are key texts. The historical background on the Reivers comes from a number of sources, including Georg MacDonald Fraser’s "), _c('em', [_vm._v("The Steel Bonnets: Story of the Anglo-Scottish Border Reivers")]), _vm._v("; Keith Durham’s "), _c('em', [_vm._v("The Border Reivers: Men at Arms")]), _vm._v("; Michael Hornsby-Smith’s "), _c('em', [_vm._v("Catholics in England")]), _vm._v(" and Alistair Moffat’s "), _c('em', [_vm._v("The Reivers: The Story of the Border Reivers")]), _vm._v(".")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("The history of Liverpool’s often fraught dance with authority is supported by a number of texts, including John Smith’s article in the "), _c('em', [_vm._v("History Workshop Journal")]), _vm._v(", 1984 and the series of articles on Liverpool strikes provided by "), _c('em', [_vm._v("catalystmedia.org.uk")]), _vm._v(". Every effort has been made in the book to quote citations from sources. A humble apology is offered for any citation omissions.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a817782","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch004.vue
// module id = 72
// module chunks = 0